module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch7",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "aria-label": "11",
      "id": "pg_11",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch7",
      "id": "ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Looking Back")])])])])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "VSB"
  }, [_vm._v("I look back on occasion.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("It takes only seconds")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("to recall the parts of me")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("that I’ve had to leave behind. All the")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("dirty fragments")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("I’ve tried to bury will resurrect")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("and reassemble for a glimpse.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("I look back")]), _vm._v(" because it forces me to remember")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("that I’ve battled as valiantly")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("as any love-starved fool")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("for the peace I now possess.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("I can say this now …")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_c('i', [_vm._v("“You’ll look back one day.")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("You’ll realize all the things you tossed and")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("turned over were not worth")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("getting into bed with, much less worrying")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("about.”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec68b368","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter7.vue
// module id = 90
// module chunks = 0